module.exports = __webpack_public_path__ + "media/images/comments-2f508e3c0f0f21b0a87ccff4cab063cd.svg";